export default {
  dashboard: {
    pageTitle: "Control Panel",
    loading: "Loading…",

    reportTooltip: "Download an executive PDF with this month's events across your portfolio, your competitors and the regulatory radar",
    reportError: "Generation failed",
    reportGenerating: "Generating report…",
    reportLabel: "Monthly report (PDF)",

    errorTitle: "Couldn't connect to the server",
    errorBody: "The API is temporarily unavailable. This can happen during restarts. Wait a few seconds and reload.",
    retry: "Retry",

    kpiToday: "Events today",
    kpiTodaySub: "last 24 h",
    kpiWeek: "Events this week",
    kpiWeekSub: "last 7 days",
    kpiPortfolio: "Affecting portfolio",
    kpiCompetitors: "Affecting competitors",
    last30Days: "last 30 days",
    brandsSub: "last 30 days · {cn} CN · {brands} brands",
    lastDataAt: "Latest data: {date}",
    lastDataNone: "No data yet",

    navToday: "Events today",
    navWeek: "Events — last 7 days",
    // 2×3 panel (R-15, §89)
    rowPortfolio: "Portfolio",
    rowCompetitors: "Competitors",
    kpiTodayShort: "Today",
    kpiWeekShort: "7 days",
    kpiMonthShort: "30 days",
    navPortfolioToday: "Portfolio — today",
    navPortfolioWeek: "Portfolio — last 7 days",
    navCompetitorsToday: "Competitors — today",
    navCompetitorsWeek: "Competitors — last 7 days",
    // R-08 (§90 phase 2A)
    noPortfolioWarning: "You are monitoring without any own products: everything you see is market. Add your portfolio so HelixScan can tell yours from the competition.",
    noPortfolioCta: "Add my products",
    navPortfolio: "Portfolio — last 30 days",
    navCompetitors: "Competitors — last 30 days",

    recentChanges: "Recent events",
    viewAll: "View all →",
    colDate: "Date",
    colPrio: "Prio.",
    colType: "Type",
    colProduct: "Product",
    colActiveIngredient: "Active Substance",
    noChangesYet: "No events detected yet",
    viewProductTooltip: "View {name} details",

    recentActivity: "Recent Activity",
    viewHistory: "View history →",
    today: "Today",
    yesterday: "Yesterday",
    noChanges: "No events",

    sourcesStatus: "Source Status",
    sourceDisabled: "Source disabled",
    lastLabel: "Last:",
    nextLabel: "Next:",
    statusOk: "OK",
    statusWarning: "WARNING",
    statusError: "ERROR",
    statusInactive: "INACTIVE",
    statusPending: "PENDING",

    typeNewEntry: "New entry",
    typePriceChange: "Price change",
    typeReimbursementChange: "Reimbursement",
    typeExclusion: "Exclusion",
    typeDeduction: "Deduction",
    typeWarning: "Notice",
    typeMarketingStatus: "Market status",
    typeEuRegistration: "EU registration",
    typeExclusivity: "Exclusivity",
  },
};
